import { styled, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0 }
  to { opacity: 1 }
`;

const fadeOut = keyframes`
  from { opacity: 1 }
  to { opacity: 0 }
`;

/**
 * Rendered height of the floating sheet, published by `SummaryMobile` so the pages
 * underneath can reserve that much space at the bottom. Unset while the sheet is not mounted.
 */
export const SUMMARY_MOBILE_HEIGHT_VAR = '--summary-mobile-height';

/** Breathing room between the end of the page content and the top of the sheet. */
const SUMMARY_MOBILE_CLEARANCE = 'calc(4rem + 24px)';

/** Sheet height before the fees block existed; stands in until the first measurement lands. */
const SUMMARY_MOBILE_FALLBACK_HEIGHT = '182px';

/** Bottom space a page under the sheet must reserve so the sheet never covers its content. */
export const SUMMARY_MOBILE_RESERVED_SPACE =
  `calc(${SUMMARY_MOBILE_CLEARANCE} + var(${SUMMARY_MOBILE_HEIGHT_VAR}, ${SUMMARY_MOBILE_FALLBACK_HEIGHT}))`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.surface.high};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  gap: 16px;
  box-shadow: 3px 0 5px rgba(0, 0, 0, 0.3);
  z-index: 999999;
`;

export const Breakdown = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const RowFullWidth = styled.section<{ $isCopyright: boolean }>`
  justify-content: ${({ $isCopyright }) => $isCopyright ? 'center' : 'space-between'};
  display: flex;
  width: 100%;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & button {
    background-color: ${({ theme }) => theme.colors.surface.low};
    border-radius: 50%;
    line-height: 0%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const TextInfo = styled.span<{ $weight: number; size: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Elza', sans-serif;
  font-size: ${({ size }) => size}px;
  font-weight: ${({ $weight }) => $weight};
  line-height: 19.36px;
  text-align: center;
  gap: 4px;
  color: ${({ theme, $weight }) => $weight === 700 ? theme.colors.text.primary : theme.colors.button.text.disabled};

  & small {

  }
`;

export const Detailing = styled.section<{ $isVisible?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
  flex: 1;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.surface.base};
  animation: ${({ $isVisible }) => ($isVisible ? fadeIn : fadeOut)} 0.5s ease-in-out;
`;

export const CopyrightContainer = styled.section`
  display: flex;
  gap: 4px;

  & strong,
  span {
    font-family: Roboto;
    font-size: 10px;
    font-weight: 400;
    line-height: 11.72px;
    text-align: left;
    color: ${({ theme }) => theme.colors.text.secondary};
  }
  & span {
    color: ${({ theme }) => theme.colors.button.text.disabled};
  }
`;
